import { Component, ViewChild } from "@angular/core";
import { MatPaginatorIntl } from '@angular/material/paginator';
import { Config } from "../../core/DefaultConfig";
import { getCustomPaginatorIntl } from "../../shared/paginator.helper";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { DeleteModel } from "../../core/models/dele.model";
import { MatPaginator, MatPaginatorModule } from "@angular/material/paginator";
import { MatSort, MatSortModule } from "@angular/material/sort";
import { MatDialog } from "@angular/material/dialog";
import { DeleteDialogComponent } from "../../shared/delete-dialog/delete-dialog.component";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatCardModule } from "@angular/material/card";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatGridListModule } from "@angular/material/grid-list";
import { TranslateModule } from "@ngx-translate/core";
import { GroupsAddEditDialogComponent } from "./add-edit-dialog/groups-add-edit-dialog.component";
import { Group } from "../../core/models/group.model";
import { AppUrlConstants } from "../../core/constants/AppUrlConstants";
import { GenericCrudService } from "../../core/services/generic-crud.service";
import { AlertDialogComponent } from "../../shared/alert-dialog/alert-dialog.component";

@Component({
  selector: "app-groups",
  standalone: true,
  imports: [
    MatFormFieldModule,
    MatInputModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatCardModule,
    MatIconModule,
    MatButtonModule,
    MatGridListModule,
    TranslateModule,
  ],
  templateUrl: "./groups.component.html",
  styleUrls: ["./groups.component.css"],
  providers: [
    { provide: MatPaginatorIntl, useValue: getCustomPaginatorIntl('Groups per page') }
  ],
})
export class GroupsComponent {
  displayedColumns: string[] = ["sr", "name", "description", "groupType", "action"];
  config = new Config();

  dataSource: MatTableDataSource<Group> = new MatTableDataSource();
  dataList: Group[] = [];
  deleteModel: DeleteModel = {
    title: "DELETE_GROUP_TITLE",
    message: "GROUP_DELETE_MESSAGE",
    deleteButtonText: "DELETE",
    cancelButtonText: "CALCEL",
  };

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    public dialog: MatDialog,
    private crudService: GenericCrudService
  ) { }

  ngOnInit() {
    this.getAll();

    // Ensure case-insensitive sorting globally
    this.dataSource.sortingDataAccessor = (item, property) => {
      if (property === "description") {
        // Ensure sorting works even if the description is null or undefined
        return item.description ? item.description.toLowerCase() : "";
      }
      const value = item[property as keyof Group];
      if (typeof value === "string") return value.toLowerCase();
      if (typeof value === "number") return value;
      return '';
    };
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  getAll() {
    this.crudService
      .getAll(AppUrlConstants.GROUP_URL + AppUrlConstants.LIST)
      .subscribe({
        next: (res: any) => {
          this.dataSource.data = res?.data || [];
        },
        error: (e) => {
          console.error("Error fetching data:", e);
        },
      });
  }

  add() {
    const dialogRef = this.dialog.open(GroupsAddEditDialogComponent);

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.dataSource.data = result;
      }
    });
  }

  edit(updateRecord: any, rowNumber: number) {
    const dialogRef = this.dialog.open(GroupsAddEditDialogComponent, {
      data: updateRecord,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.dataSource.data = result;
      }
    });
  }

  delete(deleteRecord: any, rowNumber: number) {
    const dialogRef = this.dialog.open(DeleteDialogComponent, {
      data: this.deleteModel,
    });

    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.crudService
          .delete(deleteRecord?.groupId, AppUrlConstants.GROUP_URL)
          .subscribe({
            next: (res: any) => {
              this.dataSource.data = res?.data || [];
            },
            error: (e) => {
              if (e?.status == 409) {
                const errors = e?.error?.errors;
                if (errors) {
                  for (const property in errors) {
                    this.openAlert(errors[property]);
                  }
                } else {
                  this.openAlert(e?.error?.message);
                }
              }
            },
          });
      }
    });
  }

  openAlert(message: string) {
    this.dialog.open(AlertDialogComponent, {
      data: {
        message,
        buttonText: {
          cancel: "OK",
        },
      },
    });
  }
}
